import { request, clearAllApiCache } from '@/utils/api-request';
import nacl from 'tweetnacl'
import naclUtil from 'tweetnacl-util'
import { useRouter } from 'vue-router'
import { useUserStore } from '../stores/user'
import { ElMessageBox } from 'element-plus'

const ACCESS_TOKEN = 'access_token'


export function signIn (params: any) {
  const url = '/admin/payment/manual/login'
  const newParams = {
    ...params,
    password: encrypt(params.password, params.username)
  }

  const config = {
    method: 'post',
    url,
    data: newParams
  }

  return request(config, true)
}

export function signOut (redirect = true) {
const router = useRouter()
  removeAuthToken()
  clearAllApiCache()
  if (redirect) {
    router.push({ name: 'Login' })
  }
}

function encrypt(data: any, key: any) {
  function padEnd(string: any, targetLength: any, padString: any) {
    targetLength = targetLength >> 0
    padString = String(typeof padString !== 'undefined' ? padString : ' ')
    if (string.length > targetLength) {
      return string.slice(0, targetLength)
    } else {
      targetLength = targetLength - string.length
      if (targetLength > padString.length) {
        padString += padString.repeat(Math.floor(targetLength / padString.length))
      }
      return string + padString.slice(0, targetLength)
    }
  }

  const encodeBase64 = naclUtil.encodeBase64
  const decodeUTF8 = naclUtil.decodeUTF8
  const nonce = nacl.randomBytes(24)
  const secretKey = decodeUTF8(padEnd(key, 32, '0'))
  const secretData = decodeUTF8(data)
  const encrypted = nacl.secretbox(secretData, nonce, secretKey)
  return `${encodeBase64(nonce)}:${encodeBase64(encrypted)}`
}

export function getAuthToken () {
  return localStorage.getItem(ACCESS_TOKEN) || null
}

export function removeAuthToken () {
  const userStore = useUserStore()
  localStorage.removeItem(ACCESS_TOKEN)
  userStore.user = null
  userStore.isAuthenticated = false
}

export function setAuthToken (token: any) {
  const userStore = useUserStore()
  if (token) {
    localStorage.setItem(ACCESS_TOKEN, JSON.stringify(token))
    const identity = parseJwt(token.accessToken).identity
    const userData = {
      userId: identity.user_id,
      userNum: identity.user_num,
      isDev: identity.is_dev
    }
    userStore.login(userData);    
  } else {
    removeAuthToken()
  }
}

export function checkAuth () {
  const userStore = useUserStore()
  return new Promise(resolve => {
    const authToken = getAuthToken()

    if (authToken) {
      const token = JSON.parse(authToken);
      if (!token.accessToken) {
        removeAuthToken()
        userStore.user = null
        return resolve(null)
      } else {
        const identity = parseJwt(token.accessToken).identity
        const userData = {
          userId: identity.user_id,
          userNum: identity.user_num,
          isDev: identity.is_dev
        }
        userStore.login(userData);
        return resolve(userData)
      }
    }
    return resolve(null)
  })
}

export function parseJwt (token: string) {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
  }).join(''))

  return JSON.parse(jsonPayload)
}

export function autoLogoutIfTokenExpired() {
  console.log('Checks whether the token has expired...')
  const router = useRouter();
  const userStore = useUserStore();

  const authToken = getAuthToken();
  if (!authToken) {
    return;
  }

  const token = JSON.parse(authToken);
  const parsedToken = parseJwt(token.accessToken);

  if (parsedToken.exp) {
    const currentTime = Date.now();
    const expirationTime = parsedToken.exp * 1000;

    if (currentTime >= expirationTime) {
      removeAuthToken();
      userStore.user = null;
      userStore.isAuthenticated = false;

      ElMessageBox.alert('세션이 만료되어 로그인 페이지로 이동합니다.', {
      confirmButtonText: '확인',
        callback: () => {
          router.push("/login");
        },
      });
    }
  }
}
